<template>
  <div class="card p-6 pt-7">
    <button class="delete" @click="close"></button>
    <div class="is-flex is-flex-direction-column">
      <p class="has-text-weight-bold is-size-3 mb-5">
        {{ $t("mp:new_application.modal.success.title") }}
      </p>
      <p class="mb-5">
        {{ $t("mp:new_application.modal.success.message") }}
      </p>
      <div class="is-flex is-flex-direction-row is-align-items-center mb-1">
        <b-icon icon-pack="fas" icon="check-circle" type="is-success" />
        <p class="ml-2">
          {{ $t("mp:new_application.modal.success.email_sent") }}
          <span class="has-text-weight-bold">{{ email }}</span>
          {{ $t("mp:new_application.modal.success.email_sent_after") }}
        </p>
      </div>
      <div class="is-flex is-flex-direction-row is-align-items-center mb-5">
        <b-icon icon-pack="fas" icon="check-circle" type="is-success" />
        <p class="ml-2">
          {{ $t("mp:new_application.modal.success.sms_sent") }}
          <span class="has-text-weight-bold">{{ phone }}</span>
          {{ $t("mp:new_application.modal.success.sms_sent_after") }}
        </p>
      </div>
      <p class="mb-3">
        {{ $t("mp:new_application.modal.success.bnpl_af_link") }}
      </p>
      <b-field class="mb-5">
        <b-input
          v-model="url"
          type="text"
          icon-pack="far"
          icon-right="clone"
          icon-right-clickable
          @icon-right-click="copy"
          expanded
          disabled
        />
      </b-field>
    </div>
    <b-button @click="close" type="is-blue"
      >{{ $t("mp:new_application.button.close") }}
    </b-button>
  </div>
</template>
<script>
import i18n from "../../plugins/i18n";

export default {
  name: "BnplApplicationSuccess",
  computed: {
    url() {
      const params = this.$store.getters["bnplInStoreApplication/getUrlParams"];
      return `${i18n.t("mp:bnpl_client_b2b_base_url")}/${params.financierId}/${
        params.publicId
      }`;
    },
    email() {
      return this.$store.getters["bnplInStoreApplication/getEmail"];
    },
    phone() {
      return this.$store.getters["bnplInStoreApplication/getPhone"].replace(
        /(\d{2})(\d{2})(\d{3})(\d{4})/,
        "+$1 $2 $3 $4"
      );
    },
  },
  methods: {
    close() {
      this.$router.push({
        name: "BnplB2bApplications",
      });
      this.$store.dispatch("bnplInStoreApplication/clear");
      this.$parent.close();
    },
    copy() {
      navigator.clipboard.writeText(this.url);
      this.$buefy.toast.open({
        message: this.$i18n.t("Vágólapra másolva"),
        type: "is-success",
      });
    },
  },
};
</script>
<style lang="scss">
.card {
  // position: relative;
  border-radius: 24px;

  button.delete {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  input.input {
    cursor: text !important;
  }

  .control.has-icons-right .icon {
    color: #051c3a;
  }
}
</style>
